import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ILink } from '../../../models/link';
import { ISession } from '../../../models/session';
import { PluginsService } from '../../plugins/plugins.service';
import { PreviewService } from '../../preview/preview.service';
import { environment } from '../../../../environments/environment';
import { find, propEq } from 'ramda';

@Component({
  template: `
    <div class="form-group">
      <div>
        <label *ngIf="label" for="{{ id }}">{{ label }}</label>
      </div>
      <div>
        <button type="button" class="btn btn-primary btn-sm m-r-sm" (click)="onPreviewChange('sessions.teasing')">{{ 'sessions.common.preview.teasing' | translate }}</button>
        <button type="button" class="btn btn-primary btn-sm m-r-sm" (click)="onPreviewChange('sessions.live')">{{ 'sessions.common.preview.live' | translate }}</button>
        <button type="button" class="btn btn-primary btn-sm m-r-sm" (click)="onPreviewChange('sessions.closing')">{{ 'sessions.common.preview.closing' | translate }}</button>
      </div>
      <div class="m-t-md">
        <div *ngIf="loaded" class="centered">
          <img class="img-responsive" src="{{config.preview.url}}/sessions/{{session.id}}/preview?url={{currentLink?.url}}&width={{currentLink?.size.width}}&height={{currentLink?.size.height}}&hash={{hash}}" />
        <div class="sk-spinner sk-spinner-rotating-plane preview_loader"></div>
      </div>
    </div>
  `,
  styles: [
    `
      .btn {
        border-radius: 15px;
      }
      .btn-primary {
        background-color: #111 !important;
        border-color: #111 !important;
      }
      .btn-primary:hover,
      .btn-primary:active,
      .btn-primary:visited,
      .btn-primary:focus {
        background-color: #000 !important;
        border-color: #000 !important;
      }
    `
  ],
  selector: 'preview-links'
})
export class PreviewLinksComponent implements OnInit, OnDestroy {
  @Input('label') public label: string;
  @Input('hash') public hash: string;

  private _session;
  @Input('session')
  public set session(session: ISession) {
    this._session = session;
    this.onSetSession();
  }
  public get session() {
    return this._session;
  }

  public id: string;
  public links: Array<ILink>;
  public loaded = false;
  public config = environment;
  public currentLink: ILink;

  constructor(private pluginsService: PluginsService, private previewService: PreviewService) {}

  ngOnInit() {
    this.id = '_id_' + Math.floor(Math.random() * 999 + 100);
  }

  ngOnDestroy(): void {}

  ngOnChanges() {
  }

  onPreviewChange(name: string) {
    if (Array.isArray(this.links)) {
      this.currentLink = find(propEq('name', name))(this.links);
    }
  }

  private onSetSession() {
    this.pluginsService.getAll(this.session).subscribe(plugins => {
      this.links = this.previewService.getLinks('webevent', this.session, plugins);
      this.currentLink = this.links[0];
      this.loaded = true;
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/common-livee/preview-links.component.ts